export default __webpack_public_path__ + "static/1.1_FR-7298aa000a70a4a5042bc9349fa68090.webp";